var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MainDialog'),_c('Lodaing'),_c('ShopCartDrawer'),_c('MainNav'),_c('router-view',{staticClass:"page_view"}),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }